import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SharedInvoiceView from './components/SharedInvoiceView';
import reportWebVitals from './reportWebVitals';

// Patch global fetch so all relative /api/* calls use the correct backend URL.
// This handles the 87 components that use fetch('/api/...') directly.
const API_BASE = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace(/\/api$/, '')  // strip trailing /api → get origin
  : '';

const _originalFetch = window.fetch.bind(window);
window.fetch = async (input, init) => {
  const isApiRequest = typeof input === 'string' && input.startsWith('/api/');

  if (isApiRequest) {
    if (API_BASE) {
      input = API_BASE + input;
    }
    // Always include credentials for API calls (session cookies)
    init = { credentials: 'include', ...init };
    // Also send sessionId as Cookie header if stored (fallback for browsers
    // that block third-party cookies across different domains)
    const sessionId = window.__sessionId;
    if (sessionId) {
      const existingHeaders = (init && init.headers) || {};
      init = {
        ...init,
        headers: {
          ...existingHeaders,
          'Cookie': `connect.sid=${sessionId}`,
          'X-Session-ID': sessionId
        }
      };
    }
  }

  const response = await _originalFetch(input, init);
  if (isApiRequest && response.status === 401) {
    window.dispatchEvent(new CustomEvent('auth:unauthorized'));
  }
  return response;
};

// Prevent scroll wheel from changing number input values globally.
// When a number input is focused and the user scrolls, blur it first
// so the scroll event does not increment/decrement the value.
document.addEventListener('wheel', (e) => {
  if (document.activeElement && document.activeElement.type === 'number') {
    document.activeElement.blur();
  }
}, { passive: false });

// Check if this is a shared invoice URL
const pathParts = window.location.pathname.split('/');
const isInvoiceView = pathParts[1] === 'invoice' && pathParts[2];
const isCatalogView = pathParts[1] === 'catalog';

let RootComponent;
if (isInvoiceView) {
  RootComponent = <SharedInvoiceView invoiceId={pathParts[2]} />;
} else if (isCatalogView) {
  const { default: CustomerCatalog } = require('./components/public/CustomerCatalog');
  RootComponent = <CustomerCatalog />;
} else {
  RootComponent = <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {RootComponent}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
